import { File02Icon } from '@langchain/untitled-ui-icons';

import { Link } from 'react-router-dom';

import { Tooltip } from '@/design-system';
import { cn } from '@/utils/tailwind';

import { DASHBOARD_HEADER_BUTTON_STYLE } from '../constants';

export function DocsButton({
  link,
  className,
}: {
  link: string;
  className?: string;
}) {
  return (
    <Tooltip title="Documentation" side="bottom" tooltipClassName="p-0">
      <button
        type="button"
        className={cn(DASHBOARD_HEADER_BUTTON_STYLE, className)}
      >
        <Link to={link} target="_blank">
          <File02Icon className="size-4" />
        </Link>
      </button>
    </Tooltip>
  );
}
